<template>
  <button
    type="button"
    class="wh-ib"
    :class="`wh-ib--${tone}`"
    :title="label"
    :aria-label="label"
    :data-action="action"
    :disabled="disabled"
    @click.stop="$emit('click', $event)"
  >
    <v-icon size="18">{{ icon }}</v-icon>
  </button>
</template>

<script>
/**
 * Dugme sa ikonom u redu tabele ili kartice magacina (pregled, izmena, brisanje…). Isto na računaru i telefonu;
 * klik ne otvara red ispod. `tone`: plain (podrazumevano), pri (akcenat), danger (brisanje).
 */
export default {
  name: "WarehouseRowButton",
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    tone: { type: String, default: "plain" },
    /** oznaka radnje za testove i čitače: data-action */
    action: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss">
.wh-ib {
  flex: none;
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-grid;
  place-items: center;
  border: 1px solid var(--rm-border-strong, #ddd6ce);
  border-radius: 50%;
  background: #fff;
  color: var(--rm-text, #1c1917);
  cursor: pointer;

  .v-icon.v-icon {
    color: inherit;
  }

  &:hover:not(:disabled) {
    border-color: var(--rm-accent, #c2410c);
    color: var(--rm-accent, #c2410c);
  }

  &--pri {
    color: var(--rm-accent, #c2410c);
    border-color: var(--rm-accent-border, #f5c9b3);
    background: var(--rm-accent-soft, #ffede5);
  }

  &--danger:hover:not(:disabled) {
    border-color: var(--rm-danger, #b42318);
    color: var(--rm-danger, #b42318);
    background: var(--rm-danger-soft, #fde8e6);
  }

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid var(--rm-accent, #c2410c);
    outline-offset: 2px;
  }
}

.rm-theme .wh-ib {
  width: 44px;
  height: 44px;
}
</style>
